const NAME_SPACE = 'HeroCarouselComponent';

export { NAME_SPACE };
